module.exports = __webpack_public_path__ + "img/Reiss Nelson.2f82b667.png";